import {
  LiveMonitorTopBarActions,
  LiveMonitorView,
  type LiveMonitorDemoState,
} from '@elva/ui';
import { useState } from 'react';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function LiveFeedPage() {
  const [demoState, setDemoState] = useState<LiveMonitorDemoState>('active');

  usePageTopBar({
    actions: (
      <LiveMonitorTopBarActions demoState={demoState} onDemoStateChange={setDemoState} />
    ),
    actionsVersion: demoState,
  });

  return <LiveMonitorView demoState={demoState} />;
}
